import { memo } from 'react'

import { upperFirst } from 'lodash-es'
import { useTranslation } from 'react-i18next'

import { BoxLink } from 'components/LinkedMUIComponents'
import { StateVisualizer } from 'domains/Workspaces/Audio/Streams'
import { General as StreamGeneral } from 'domains/Workspaces/Streams/General'
import { audioStreamGeneralRoute } from 'pages/NWPlatform/Workspaces/Workspace/Audio/Streams/Stream'
import { avcTaskConfigRoute } from 'pages/NWPlatform/Workspaces/Workspace/AvcTasks/AvcTask'

const GeneralRaw = () => {
  const { t } = useTranslation(['domain'])

  const { audiostreamId: streamId } = audioStreamGeneralRoute.useParams()

  return (
    <StreamGeneral
      streamKind="audio"
      streamId={streamId}
      TaskLink={(taskId, content) => (
        <BoxLink
          key={taskId}
          sx={{ display: 'block', textDecoration: 'none', color: 'inherit' }}
          from={audioStreamGeneralRoute.fullPath}
          to={avcTaskConfigRoute.to}
          params={{ avcTaskId: taskId }}
        >
          {content}
        </BoxLink>
      )}
      StateSlot={(isLive) => (
        <StateVisualizer state={isLive} variant="text-sm">
          {upperFirst(isLive ? t('domain:Workspace.Streams.live') : t('domain:Workspace.Streams.ended'))}
        </StateVisualizer>
      )}
    />
  )
}

export const General = memo(GeneralRaw)
